<script setup>
import PhoneIcon from "./icons/IconPhone.vue"
import TopHeaderItem from "./TopHeaderItem.vue"
import EmailIcon from './icons/IconEmail.vue'
const phone = "+7(495)665-67-88"
const ext = "доб. 717"
const email="info@forwardrnd.com"

const phoneshort = phone.replace(/\(/g,"").replace(/\)/g,"").replace(/-/g,"")

</script>

<template>
<div class="filledblack d-flex justify-content-between">
    <div class="text-center flex-grow-1">
        <TopHeaderItem>
            <template #icon><PhoneIcon /></template>
            <a :href="'tel:'+phoneshort">{{phone}}</a>&nbsp;<span class="ext">{{ext}}</span>
        </TopHeaderItem>
    </div>
    <div class="text-end">
        <TopHeaderItem>
            <template #icon><EmailIcon /></template>
            <a :href="'mailto:'+email">{{email}}</a>
        </TopHeaderItem>
    </div>
</div>
</template>

<style scoped>
.filledblack {
    background-color: var(--clr-yellow-pale);
    background-image: url("data:image/svg+xml,%3Csvg width='100' height='80' viewBox='0 0 100 80' xmlns='http://www.w3.org/2000/svg'%3E%3Ctext x='15' y='18' font-family='sans-serif' font-size='13' fill='%2399906a' opacity='0.2' text-anchor='middle'%3E▲%3C/text%3E%3Ctext x='40' y='58' font-family='sans-serif' font-size='13' fill='%2399906a' opacity='0.2' text-anchor='middle'%3E▼%3C/text%3E%3Ctext x='65' y='32' font-family='sans-serif' font-size='13' fill='%2399906a' opacity='0.2' text-anchor='middle'%3E▲%3C/text%3E%3Ctext x='88' y='64' font-family='sans-serif' font-size='13' fill='%2399906a' opacity='0.2' text-anchor='middle'%3E▼%3C/text%3E%3Ctext x='50' y='12' font-family='sans-serif' font-size='13' fill='%2399906a' opacity='0.2' text-anchor='middle'%3E▼%3C/text%3E%3Ctext x='80' y='44' font-family='sans-serif' font-size='13' fill='%2399906a' opacity='0.2' text-anchor='middle'%3E▲%3C/text%3E%3Ctext x='28' y='42' font-family='sans-serif' font-size='13' fill='%2399906a' opacity='0.2' text-anchor='middle'%3E▲%3C/text%3E%3C/svg%3E");
    background-repeat: repeat;
    font-size: 0.8rem;
    padding: 0.25rem 1.5rem;
}
a {
    color: var(--clr-text);
    text-decoration: none;
}
a:hover {
    color: var(--clr-black);
    text-decoration: underline;
}
a:visited {
    color: var(--clr-text);
    text-decoration: none;
}
.ext {
    font-size: 0.7em;
    color: var(--clr-text);
}
</style>